/* eslint-disable no-param-reassign */
const ELEMENTS_IN_USE = {
    textWrapper: '.js--toggle-height'
};

export default function toggleHeight() {
    const wrapper = document.querySelectorAll(ELEMENTS_IN_USE.textWrapper);

    if (!wrapper) return false;

    wrapper.forEach((item) => {
        if (item.clientHeight > 22) {
            item.style.height = '18px';
            item.style.overflowY = 'hidden';
            const opener = document.createElement('div');
            opener.classList.add('auction-info__opener');
            opener.innerText = 'Подробнее';
            const closer = document.createElement('div');
            closer.classList.add('auction-info__opener');
            closer.innerText = 'Свернуть';
            item.parentElement.appendChild(opener);

            opener.addEventListener('click', () => {
                item.style.height = 'auto';
                item.parentElement.removeChild(opener);
                item.parentElement.appendChild(closer);
            });

            closer.addEventListener('click', () => {
                item.style.height = '18px';
                item.parentElement.removeChild(closer);
                item.parentElement.appendChild(opener);
            });
        }
    });
}
